import Log, {Errors} from "@repo/logging";

import {inSandbox, Sandbox} from "#testing/sandbox/in-sandbox.ts";

/**
 * A check for verifying if our GQL operations should be mocked out. This is
 * used to make sure that our GraphQL pieces aren't being used in tests
 * without being mocked out first. This function should only be used directly
 * from create-client.js.
 *
 * @param {{query, variables}} queryParams settings to display to the dev to
 *                                         make it easier to debug.
 */
const checkMockedGql = ({
    query,
    variables,
}: {
    query: string;
    variables: any;
}) => {
    if (process.env.NODE_ENV === "test" || inSandbox() === Sandbox.Storybook) {
        Log.error(
            `GraphQL called during testing, please use either:
    - withTestHarness and the gql adapter,
    - or, an appropriate mocked ApolloGqlClient passed to your function under test
    - or, an appropriate mocked ApolloGqlClient returned from a getUnsafeApolloGqlClient mock

    Query:
        ${query.trim()}
    Variables: ${JSON.stringify(variables)}`,
            Errors.Internal,
        );
    }
};

export default checkMockedGql;
